// extracted by mini-css-extract-plugin
export default {"intake_form":"Intake_intake_form__RVJH+"};